import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { FormBuilder, FormGroup, Validators, FormArray } from '@angular/forms';
import { ActivatedRoute, Router } from "@angular/router";
import { loadingFade } from '../../animacoes';

import { SinistroService } from '../services/sinistro.service';
import { VeiculoService } from '../services/veiculo.service';
import { ProfissionalService } from '../services/profissional.service';
import { UnidadeMedidaService } from '../services/unidade-medida.service';
import { PecaService } from '../services/peca.service';
import { TipoServicoService } from '../services/tipo-servico.service';
import { AuthService } from '../services/auth.service';
import { UploaderService } from '../services/uploader.service';

import * as Datepicker from 'js-datepicker';
import * as moment from 'moment';
import Swal from 'sweetalert2';


@Component({
	selector: 'app-sinistro-edit',
	templateUrl: './sinistro-edit.component.html',
	styleUrls: ['./sinistro-edit.component.css'],
	animations: [loadingFade]
})
export class SinistroEditComponent implements OnInit {
	public loading;
	public submitting = false;
	public sinistro_id = null;

	public veiculos = [];
	public profissionais = [];
	public unidade_medida_array = [];
	public pecas_array = [];
	public tipos_servicos = [];
	public tipo = [
		{'tipo_id': 'A', 'tipo_nome': 'Avaria'},
		{'tipo_id': 'S', 'tipo_nome': 'Sinistro'}
	];
	public file;
	public file_name;
	public file_name_upload = [];

	public natureza = [
		{'natureza_id': 'P', 'natureza_nome': 'Próprio'},
		{'natureza_id': 'T', 'natureza_nome': 'Terceiro'}
	];


	public qtde_char_descricao = 0;
	public total_pecas = 0;
	public total_servicos = 0;

	public formSinistro: FormGroup;

	// datepickers
	public sinistro_data_dp;

	public file_name_BOAT;
	public file_name_InvestigacaoAcidente;
	public file_name_DocVeiculo;
	public file_name_CNHCondutor;

	public img_extensions = ['png', 'jpg', 'jpeg', 'pdf'];
	private imageBOAT: string = '';
	private imageInvestigacaoAcidente: string = '';
	private imageDocVeiculo: string = '';
	private imageCNHCondutor: string = '';

	constructor(private route: ActivatedRoute,
		private fb: FormBuilder,
		private authSvc: AuthService,
		private sinistroSvc: SinistroService,
		private veiculoSvc: VeiculoService,
		private profissionalSvc: ProfissionalService,
		private unidadeMedidaSvc: UnidadeMedidaService,
		private pecaSvc: PecaService,
		private tipoServicoSvc: TipoServicoService,
		private uploaderSvc: UploaderService,
		private location: Location,
		private router: Router, ) { }

	ngOnInit() {
		this.criaForm();
		this.pegaVeiculos();
		this.pegaProfissionais();
		this.pegaUnidadeMedida();
		this.pegaPecas();
		this.pegaTiposServicos();

		//this.loading = true;

		this.route.params.subscribe(params => {
			if (params.id) {
				this.sinistro_id = params.id;
				this.sinistroSvc.getSinistro(params.id).then((data: any) => {

					/*this.file_name_upload[0] = data.sinistro_boat;
					this.file_name_upload[1] = data.sinistro_investigacao;
					this.file_name_upload[2] = data.sinistro_doc_veiculo;
					this.file_name_upload[3] = data.sinistro_cnh;
					this.file_name[0] = data.sinistro_boat_nome;
					this.file_name[1] = data.sinistro_investigacao_nome;
					this.file_name[2] = data.sinistro_doc_veiculo_nome;
					this.file_name[3] = data.sinistro_cnh_nome;*/

					this.preencheForm({
						sinistro_id: data.sinistro_id,
						veiculo_id: data.veiculo_id,
						profissional_id: data.profissional_id,
						sinistro_data: data.sinistro_data != null ? moment(data.sinistro_data).format('DD/MM/YYYY') : '',
						sinistro_tipo: data.sinistro_tipo,
						sinistro_natureza: data.sinistro_natureza,
						sinistro_nf_servico: data.sinistro_nf_servico,
						sinistro_nf_peca: data.sinistro_nf_peca,
						sinistro_descricao: data.sinistro_descricao,
						sinistro_boat: null,
						sinistro_investigacao: null,
						sinistro_doc_veiculo: null,
						sinistro_cnh: null,
						pecas: [],
						servicos: [],
					});


					if (data.despesa_descricao)
						this.qtde_char_descricao = data.despesa_descricao.length;

					if(data.pecas.length > 0){
						for (let peca of data.pecas) {
							this.addPeca(peca.peca_id, peca.sinistro_peca_quantidade, peca.unidade_medida_id, peca.sinistro_peca_valor, peca.sinistro_peca_valor_total);
						}
					}
					else{
						this.addPeca();
					}
					if(data.servicos.length > 0){
						for (let servico of data.servicos) {
							this.addServico(servico.servico_id, servico.sinistro_servico_quantidade, servico.sinistro_servico_descricao, servico.sinistro_servico_valor, servico.sinistro_servico_valor_total);
						}
					}
					else{
						this.addServico();
					}
					this.calculaPecas();
					this.calculaServicos();	

					
				});
			}
			else {
				this.addPeca();
				this.addServico();
				this.loading = false;
			}
		});
	}

	criaForm() {
		this.formSinistro = this.fb.group({
			sinistro_id: null,
			veiculo_id: [null, Validators.required],
			profissional_id: [null, Validators.required],
			sinistro_data: [null, Validators.required],
			sinistro_tipo: [null, Validators.required],
			sinistro_natureza: [null, Validators.required],
			sinistro_nf_servico: null,
			sinistro_nf_peca: null,
			sinistro_boat: null,
			sinistro_investigacao: null,
			sinistro_doc_veiculo: null,
			sinistro_cnh: null,
			sinistro_descricao: null,
			pecas: this.fb.array([]),
			servicos: this.fb.array([]),
		});

		moment.locale('pt-Br');
		this.sinistro_data_dp = Datepicker('#sinistro_data', {
			customMonths: moment.months(),
			customDays: moment.weekdaysShort(),
			overlayPlaceholder: 'Preencha o ano',
			overlayButton: 'Enviar',
			formatter: (element, date) => {
				let formatted = moment(date).format('DD/MM/YYYY');
				this.formSinistro.controls['sinistro_data'].setValue(formatted);
			},
		});
	}

	preencheForm(dados) {
		this.formSinistro.setValue(dados);
	}

	onKeyUpDescricao(e) {
		this.qtde_char_descricao = this.formSinistro.value.sinistro_descricao.length;
	}

	pegaVeiculos() {
		this.veiculoSvc.getVeiculosByUsuario(this.authSvc.getUsuarioId()).then((data: any) => {
			this.veiculos = data;
		}).catch((err) => {
			console.log(err);
		});
	}

	pegaProfissionais() {
		this.profissionalSvc.getProfissionaisByUsuario(this.authSvc.getUsuarioId()).then((data: any) => {
			this.profissionais = data;
		}).catch((err) => {
			console.log(err);
		});
	}

	pegaUnidadeMedida() {
		this.unidadeMedidaSvc.getUnidadesMedida().then((data: any[]) => {
			this.unidade_medida_array = data;
		}).catch((err) => {
			console.log(err);
		});
	}

	pegaPecas() {
		this.pecaSvc.getPecas().then((data: any[]) => {
			this.pecas_array = data;
		}).catch((err) => {
			console.log(err);
		});
	}

	pegaTiposServicos() {
		this.tipoServicoSvc.getTiposServico().then((data: any[]) => {
			this.tipos_servicos = data;
		}).catch((err) => {
			console.log(err);
		});
	}

	enviaSinistro() {
		if (this.formSinistro.valid) {
			this.submitting = true;

			let toSend = this.formSinistro.value;

			console.log("file.le = " + this.file);
			if(this.file != null){
				if(this.file.length > 0){
					let formData = new FormData();
					for(let i = 0; i < this.file.length; i++){
						if(this.file[i][0] != null){
							formData.append("file" + i, this.file[i][0],this.file_name_upload[i]);
						}
					}
					formData.set('dir', 'sinistros');
					this.uploaderSvc.sendFile(formData);
				}
			}


			toSend.sinistro_boat 				= this.file_name_upload[0] != null ? this.file_name_upload[0] : '';
			toSend.sinistro_investigacao 		= this.file_name_upload[1] != null ? this.file_name_upload[1] : '';
			toSend.sinistro_doc_veiculo 		= this.file_name_upload[2] != null ? this.file_name_upload[2] : '';
			toSend.sinistro_cnh			 		= this.file_name_upload[3] != null ? this.file_name_upload[3] : '';

			toSend.sinistro_boat_nome			= this.file_name_BOAT;
			toSend.sinistro_investigacao_nome	= this.file_name_InvestigacaoAcidente;
			toSend.sinistro_doc_veiculo_nome	= this.file_name_DocVeiculo;
			toSend.sinistro_cnh_nome			= this.file_name_CNHCondutor;


			//Adiciona Uploads 
			toSend.sinistro_boat_arquivo = this.imageBOAT;
			toSend.sinistro_investigacao_arquivo = this.imageInvestigacaoAcidente;
			toSend.sinistro_doc_veiculo_arquivo = this.imageDocVeiculo;
			toSend.sinistro_cnh_arquivo = this.imageCNHCondutor;

			toSend.sinistro_valor = this.total_pecas + this.total_servicos;
			
			if (this.sinistro_id === null) { // criar
				this.sinistroSvc.criaSinistro(toSend).then((data) => {
					console.log('resp', data);
					Swal.fire({
						type: 'success',
						title: 'Avaria/Sinistro cadastrado com sucesso!',
						onClose: () => {
							this.router.navigate(['home/sinistro']);
						}
					});
				}).catch(err => {
					console.log(err);
					this.submitting = false;
					Swal.fire({
						type: 'error',
						title: 'Ops! Algo de errado aconteceu!',
						text: 'Tente novamente mais tarde.'
					});
				});
			}
			else { // editar
				this.sinistroSvc.editaSinistro(toSend).then((data) => {
					console.log('resp', data);
					Swal.fire({
						type: 'success',
						title: 'Avaria/Sinistro alterado com sucesso!',
						onClose: () => {
							this.router.navigate(['home/sinistro']);
						}
					});
				}).catch(err => {
					console.log(err);
					this.submitting = false;
					Swal.fire({
						type: 'error',
						title: 'Ops! Algo de errado aconteceu!',
						text: 'Tente novamente mais tarde.'
					});
				});
			}
		}
		else{
			for (let field in this.formSinistro.controls) {
				let campo = this.formSinistro.get(field);
				campo.markAsTouched();
			}
			this.submitting = false;
			Swal.fire({
				type: 'error',
				title: 'Atenção!',
				text: 'Verifique os campos obrigatórios e tente novamente.'
			});
		}
	}

	invalid(nome) {
		let input = this.formSinistro.get(nome);
		return input.touched && input.invalid;
	}

	createItemPeca(peca_id = null, sinistro_peca_quantidade = null, unidade_medida_id = null, sinistro_peca_valor = '', sinistro_peca_valor_total = '') {
		return this.fb.group({
			peca_id: [peca_id],
			sinistro_peca_quantidade: [sinistro_peca_quantidade],
			unidade_medida_id: [unidade_medida_id],
			sinistro_peca_valor: [sinistro_peca_valor],
			sinistro_peca_valor_total: [sinistro_peca_valor_total]
		})
	}

	addPeca(peca_id = null, sinistro_peca_quantidade = null, unidade_medida_id = null, sinistro_peca_valor = null, sinistro_peca_valor_total = null) {
		const despesas = this.formSinistro.get('pecas') as FormArray;
		if (peca_id != null && sinistro_peca_quantidade != null && unidade_medida_id != null && sinistro_peca_valor != null && sinistro_peca_valor_total != null) {
			despesas.push(this.createItemPeca(peca_id, sinistro_peca_quantidade, unidade_medida_id, sinistro_peca_valor, sinistro_peca_valor_total));
		}
		else {
			despesas.push(this.createItemPeca());
		}
	}

	removePeca(index) {
		const despesas = this.formSinistro.get('pecas') as FormArray;
		despesas.controls.length == 1 || despesas.removeAt(index);
		this.calculaPecas();
	}

	calculaPecas(i = null) {
		let pecas = this.formSinistro.get('pecas') as FormArray;
		let soma = 0;
		for (let peca of pecas.controls) {
			soma += peca.value['sinistro_peca_quantidade'] * peca.value['sinistro_peca_valor'];
		}
		this.total_pecas = soma;
		if (i != null) {
			pecas.at(i).get('sinistro_peca_valor_total').setValue(pecas.at(i).get('sinistro_peca_quantidade').value * pecas.at(i).get('sinistro_peca_valor').value);
		}
	}

	createItemServico(servico_id = null, sinistro_servico_quantidade = null, sinistro_servico_descricao = null, sinistro_servico_valor = '', sinistro_servico_valor_total = '') {
		return this.fb.group({
			servico_id: [servico_id],
			sinistro_servico_descricao: [sinistro_servico_descricao],
			sinistro_servico_quantidade: [sinistro_servico_quantidade],
			sinistro_servico_valor: [sinistro_servico_valor],
			sinistro_servico_valor_total: [sinistro_servico_valor_total]
		});
	}

	addServico(servico_id = null, sinistro_servico_quantidade = null, unidade_medida_id = null, sinistro_servico_valor = null, sinistro_servico_valor_total = null) {
		const despesas = this.formSinistro.get('servicos') as FormArray;
		if (servico_id != null && sinistro_servico_quantidade != null && unidade_medida_id != null && sinistro_servico_valor != null && sinistro_servico_valor_total != null) {
			despesas.push(this.createItemServico(servico_id, sinistro_servico_quantidade, unidade_medida_id, sinistro_servico_valor, sinistro_servico_valor_total));
		}
		else {
			despesas.push(this.createItemServico());
		}
	}

	removeServico(index) {
		const despesas = this.formSinistro.get('servicos') as FormArray;
		despesas.controls.length == 1 || despesas.removeAt(index);
		this.calculaServicos();
	}

	calculaServicos(i = null) {
		let servicos = this.formSinistro.get('servicos') as FormArray;
		let soma = 0;
		for (let servico of servicos.controls) {
			soma += servico.value['sinistro_servico_quantidade'] * servico.value['sinistro_servico_valor'];
		}
		this.total_servicos = soma;

		if (i != null) {
			servicos.at(i).get('sinistro_servico_valor_total').setValue(servicos.at(i).get('sinistro_servico_quantidade').value * servicos.at(i).get('sinistro_servico_valor').value);
		}
	}

	onFileSelect(e, index){
		this.file[index] = <File>e.target.files;
		this.file_name[index] = this.file[index][0].name;
		this.file_name_upload[index] = this.file[index][0].name.split('.');
		this.file_name_upload[index] = this.file_name_upload[index][0] + moment().format('x') + '.' + this.file_name_upload[index][1];
	}

	onDocumentoSelect(e, typeSend) {
	
		this.file = <File>e.target.files;
		if(typeSend == "BOAT"){
			this.file_name_BOAT = this.file[0].name;
		}else if(typeSend == "InvestigacaoAcidente"){
			this.file_name_InvestigacaoAcidente = this.file[0].name;
		}
		else if(typeSend == "docVeiculo"){
			this.file_name_DocVeiculo = this.file[0].name;
		}
		else if(typeSend == "cnh"){
			this.file_name_CNHCondutor = this.file[0].name;
		}


	}

	truncateText(string){
		if(string.length > 20){
			return string.slice(0, 20) + '...';
		}
		return string;
	}




	handleInputChange(e, typeSend) {

		 this.onDocumentoSelect(e, typeSend)
		 var file = e.dataTransfer ? e.dataTransfer.files[0] : e.target.files[0];
		 var pattern = /image-*/;
		 var reader = new FileReader();
	  
		  let extensions = false;
		  let typeFile = file.type.split("/");
	  
		  for(let type of this.img_extensions){
	  
			if(type == typeFile[1]){
			  extensions = true;
			}
	  
		  }

		 if (!extensions) {

			let arquivoErro = "";
			if(typeSend == "BOAT"){
				this.formSinistro.controls.sinistro_boat.setValue(null)
				this.file_name_BOAT = "Selecionar arquivo";
				arquivoErro += "B.O.A.T. ";
			}else if(typeSend == "InvestigacaoAcidente"){
				this.formSinistro.controls.sinistro_investigacao.setValue(null)
				this.file_name_InvestigacaoAcidente = "Selecionar arquivo";
				arquivoErro += "Investigação Acidente.  ";
			}else if(typeSend == "docVeiculo"){
				this.formSinistro.controls.sinistro_doc_veiculo.setValue(null)
				this.file_name_DocVeiculo = "Selecionar arquivo";
				arquivoErro += "Doc Veículo.  ";
			}else if(typeSend == "cnh"){
				this.formSinistro.controls.sinistro_cnh.setValue(null)
				this.file_name_CNHCondutor = "Selecionar arquivo";
				arquivoErro += "CNH Condutor.  ";
			}

			alert('Formato invalido! - ' + arquivoErro); 

		   return;		   
		 }



		if(typeSend == "BOAT"){
			reader.onload = this._handleReaderLoaded_BOAT.bind(this);
			reader.readAsDataURL(file);
		}else if(typeSend == "InvestigacaoAcidente"){
			reader.onload = this._handleReaderLoaded_InvestigacaoAcidente.bind(this);
			reader.readAsDataURL(file);
		}else if(typeSend == "docVeiculo"){
			reader.onload = this._handleReaderLoaded_DocVeiculo.bind(this);
			reader.readAsDataURL(file);
		}else if(typeSend == "cnh"){
			reader.onload = this._handleReaderLoaded_CNH.bind(this);
			reader.readAsDataURL(file);
		}

	   }

	   _handleReaderLoaded_BOAT(e) {
		let reader = e.target;
		this.imageBOAT = reader.result;
	   }	   

	   _handleReaderLoaded_InvestigacaoAcidente(e) {
		 let reader = e.target;
		 this.imageInvestigacaoAcidente = reader.result;
	   }

	  _handleReaderLoaded_DocVeiculo(e) {
		let reader = e.target;
		this.imageDocVeiculo = reader.result;
	  }

	  _handleReaderLoaded_CNH(e) {
		let reader = e.target;
		this.imageCNHCondutor = reader.result;
	  }


}
